import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = {
  key: 0,
  for: "name",
  class: "form-label"
}
const _hoisted_3 = { key: 1 }

import { computed, ref, watch, PropType } from 'vue';
import i18n from "@/i18n/index"


export default /*@__PURE__*/_defineComponent({
  __name: 'DateRangeField',
  props: {
  modelValue: {
    type: Array as PropType<Date[] | null>, // Use PropType to define the type
    default: null,
  },
  type: { type: String, default: 'text' },
  readonly: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },

  label: { type: String },
  typeStyle: { type: String, default: "" },
  v: {
    type: Object,
  },

  fixedDays: { type: Number, default: 1 },
  isFixedDays: { type: Boolean, default: false },
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props;



const maxDate = computed(() => {
  if (props?.isFixedDays) {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // Ensure two digits for month
    return `${year}-${month}-${props?.fixedDays ?? 1}T01:00:00Z`;
  }
  return false
});

const emits = __emit;

const internalValue = ref<Date[] | null>(props.modelValue);

watch(internalValue, (newValue) => {
  if (newValue) {
    if (newValue?.length >= 2) {
      if (newValue[0] instanceof Date && newValue[1] instanceof Date) {
        console.log(newValue[1])
        emits('update:modelValue', [
          newValue[0].toISOString().split('T')[0],
          newValue[1].toISOString().split('T')[0]
        ]);
      }
    } else {
      emits('update:modelValue', [
        null,
        null
      ]);
    }
  }
});

watch(() => props.modelValue, (newValue) => {
  internalValue.value = newValue;
});




return (_ctx: any,_cache: any) => {
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("b", _hoisted_2, _toDisplayString(__props.label), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_VueDatePicker, {
      range: "",
      modelValue: internalValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalValue).value = $event)),
      disabled: __props.disabled,
      readonly: __props.readonly,
      locale: "fr",
      cancelText: _unref(i18n).t('button.cancel'),
      selectText: _unref(i18n).t('button.select'),
      "enable-time-picker": false,
      "max-date": maxDate.value
    }, null, 8, ["modelValue", "disabled", "readonly", "cancelText", "selectText", "max-date"]),
    (__props.v)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.v?.$errors, (error) => {
            return (_openBlock(), _createElementBlock("span", {
              class: "text-danger",
              key: error.$uid
            }, [
              _createTextVNode(" - " + _toDisplayString(error.$message) + " ", 1),
              _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1))
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})